import { RootState } from '../store'

export const selectDocument = (state: RootState) => state.document.document
export const selectDocuments = (state: RootState) => state.document.documents
export const selectDocumentLoading = (state: RootState) =>
  state.document.loading
export const selectDocumentError = (state: RootState) => state.document.error
